exports.components = {
  "component---src-pages-404-index-tsx": () => import("./../../../src/pages/404/index.tsx" /* webpackChunkName: "component---src-pages-404-index-tsx" */),
  "component---src-templates-article-index-tsx": () => import("./../../../src/templates/article/index.tsx" /* webpackChunkName: "component---src-templates-article-index-tsx" */),
  "component---src-templates-default-cms-index-tsx": () => import("./../../../src/templates/defaultCms/index.tsx" /* webpackChunkName: "component---src-templates-default-cms-index-tsx" */)
}

